export const ROLES = [
  {
    role: 'system',
  },
  {
    role: 'user',
  },
  {
    role: 'assistant',
  },
  {
    role: 'developer',
  },
]

export const MODELS = [
  {
    label: 'gpt-4.1',
    value: 'gpt-4.1'
  },
  {
    label: 'gpt-4o',
    value: 'gpt-4o'
  },
  {
    label: 'gpt-5',
    value: 'gpt-5'
  },
  {
    label: 'gpt-5.1',
    value: 'gpt-5.1'
  },
  {
    label: 'gpt-5-mini',
    value: 'gpt-5-mini'
  },
  {
    label: 'gpt-5.2',
    value: 'gpt-5.2'
  },
]
